import type { ReactNode } from 'react'

import { noticeTone, type NoticeTone } from './kit'

/** A line or banner that must be read: its own background, so the text never sits on the bare page. For a chip use Badge. */
export function Notice({
  tone = 'warning',
  icon,
  className = '',
  children,
}: {
  tone?: NoticeTone
  icon?: ReactNode
  className?: string
  children: ReactNode
}) {
  return (
    <div
      role={tone === 'danger' ? 'alert' : undefined}
      className={`flex items-start gap-2 rounded-lg border px-3 py-2 text-sm ${noticeTone(tone)} ${className}`}
    >
      {icon}
      <div className="min-w-0">{children}</div>
    </div>
  )
}
